// TanStack Query-hooks for selskapsinfo. Statisk oppslags-side → ingen polling.
// Mønster fra admin/api/hooks.ts (keepPreviousData på søk) + høy staleTime der kilden er treg.
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { selskapsinfoApi } from "./selskapsinfoApi";

export function useCompanySearch(q: string) {
  return useQuery({
    queryKey: ["selskapsinfo", "search", q],
    enabled: q.trim().length >= 2,
    placeholderData: keepPreviousData,
    queryFn: () => selskapsinfoApi.search(q),
  });
}

export function useBrreg(orgnr: string) {
  return useQuery({
    queryKey: ["selskapsinfo", "brreg", orgnr],
    enabled: !!orgnr,
    staleTime: 60 * 60 * 1000, // Brreg endrer seg sjelden
    queryFn: () => selskapsinfoApi.brreg(orgnr),
  });
}

export function useEksponering(orgnr: string) {
  return useQuery({
    queryKey: ["selskapsinfo", "eksponering", orgnr],
    enabled: !!orgnr,
    queryFn: () => selskapsinfoApi.eksponering(orgnr),
  });
}

export function usePengestrom(orgnr: string) {
  return useQuery({
    queryKey: ["selskapsinfo", "pengestrom", orgnr],
    enabled: !!orgnr,
    staleTime: 60 * 60 * 1000, // geokoding er tregt — cache lenge
    queryFn: () => selskapsinfoApi.pengestrom(orgnr),
  });
}
